import React, { useState } from 'react';

import {
  updateImageCaption,
  insertParagraphAfterImage,
} from '../dom/RichTextEditorHelpers';

const EditableCaption = ({ componentId, caption, contentEditable, setState, classNames = {} }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(caption || '');

  const handleClick = (e) => {
    if (contentEditable) {
      e.stopPropagation();
      setIsEditing(true);
      setEditValue(caption || '');
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
    if (editValue !== caption) {
      updateImageCaption({ componentId, caption: editValue, setState });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setIsEditing(false);
      if (editValue !== caption) {
        updateImageCaption({ componentId, caption: editValue, setState });
      }
      insertParagraphAfterImage({ componentId, setState });
    }
    if (e.key === 'Escape') {
      setEditValue(caption || '');
      setIsEditing(false);
    }
    e.stopPropagation();
  };

  const hasVisibleCaption = caption && caption !== '\u200b';

  if (isEditing) {
    return (
      <input
        type="text"
        className={classNames.captionInput}
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        autoFocus
        placeholder="Add a caption..."
      />
    );
  }

  if (hasVisibleCaption) {
    return (
      <p
        id={classNames.imageCaption}
        className={contentEditable ? classNames.captionEditable : ''}
        onClick={handleClick}
      >
        {caption}
      </p>
    );
  }

  if (contentEditable) {
    return (
      <p
        className={classNames.captionPlaceholder}
        onClick={handleClick}
      >
        Add a caption...
      </p>
    );
  }

  return null;
};

export default EditableCaption;
